import PopupManager from './popup-manager.js';

const SignPopup = {
    init() {
        this.registerPopup('sign-in', 'in');
    },

    registerPopup(popupType, formType) {
        PopupManager.register(popupType, {
            size: 'wide',
            bodyClasses: ['popup__body--sign'],
            skipDefaultFormInit: true,
            preserveFormIds: true,
            onOpen: (container) => {
                const form = container.querySelector('form[data-signin-form]');
                if (!form) {
                    return;
                }

                if (form.hasAttribute('data-signin-initialized')) {
                    form.removeAttribute('data-signin-initialized');
                }

                if (!form.getAttribute('data-type')) {
                    form.setAttribute('data-type', formType);
                }

                if (!form.id) {
                    form.id = `${popupType}-form-${Date.now()}`;
                }

                const bindForm = () => {
                    if (window.SignIn && typeof window.SignIn.initForm === 'function') {
                        window.SignIn.initForm(form);
                    }
                    if (window.InputLabels && typeof window.InputLabels.init === 'function') {
                        window.InputLabels.init();
                    }
                };

                if (window.SignIn && typeof window.SignIn.initForm === 'function') {
                    bindForm();
                    return;
                }

                import(/* webpackChunkName: "auth" */ './auth.js').then((m) => {
                    if (!window.SignIn) window.SignIn = m.default;
                    bindForm();
                });
            },
        });
    },
};

export default SignPopup;

window.SignPopup = SignPopup;

